import { Box, Button } from '@mui/material';
import { useMemo, useState } from 'react';

import { getShortAddr } from 'modules/common/utils/getShortAddr';

import { useConnection } from 'modules/auth';
import { getWalletIcon } from 'modules/auth/components/WalletIcon';
import { WalletDropdown } from '../WalletDropdown';

const id = 'connected-wallet-dropdown';

export function ConnectedWallet(): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const { walletId, address = '' } = useConnection();

  const shortAddr = useMemo(() => getShortAddr(address), [address]);

  const handleTooltipOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleTooltipClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        sx={{
          gap: 1,
          color: 'common.white',
          height: 40,
          p: theme => theme.spacing(0.75, 2, 0.75, 1.25),
          minWidth: 156,
          borderRadius: '1000px',
        }}
        size="small"
        onClick={handleTooltipOpen}
      >
        <Box component={getWalletIcon(walletId)} height={28} minWidth={28} />

        {shortAddr}
      </Button>

      <WalletDropdown
        id={id}
        anchorEl={anchorEl}
        handleClose={handleTooltipClose}
      />
    </>
  );
}
